/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Intervals_Importing_ShortInputs */

const en_ui_intervals_importing_short = /** @type {(inputs: Ui_Intervals_Importing_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing…`)
};

const de_ui_intervals_importing_short = /** @type {(inputs: Ui_Intervals_Importing_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importiere…`)
};

/**
* | output |
* | --- |
* | "Importing…" |
*
* @param {Ui_Intervals_Importing_ShortInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_intervals_importing_short = /** @type {((inputs?: Ui_Intervals_Importing_ShortInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Intervals_Importing_ShortInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_intervals_importing_short(inputs)
	return de_ui_intervals_importing_short(inputs)
});